import { Link } from "react-router-dom";
import { MapPin, Phone, ArrowRight } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { ConsultationCTA } from "@/components/ConsultationCTA";
import { AREAS } from "@/data/areas";
import { COMPANY } from "@/lib/constants";

export default function ServiceAreas() {
  useSEO({
    title: "Service Areas | Home Care Across Northern Virginia | Esprit",
    description: "Esprit Home Healthcare serves Annandale, Fairfax, Arlington, Alexandria, Falls Church, Vienna, McLean, Springfield and communities across Northern Virginia.",
    canonical: "/service-areas",
  });

  return (
    <div>
      <PageHeader
        overline="Service Areas"
        title="Caring for Northern Virginia"
        subtitle="We're specialists in serving Northern Virginia home care patients. Select your community to learn how we can help — and if you don't see your town, just give us a call."
      />

      <section className="container-page py-16 lg:py-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {AREAS.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.04}>
              <Link to={`/service-areas/${a.slug}`} data-testid={`area-link-${a.slug}`}
                className="group flex items-center justify-between gap-4 bg-card rounded-2xl border border-border p-6 hover:border-primary hover:shadow-md transition-all">
                <div className="flex items-center gap-4">
                  <span className="grid place-items-center w-12 h-12 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                    <MapPin className="w-6 h-6" />
                  </span>
                  <div>
                    <p className="font-heading font-bold text-xl text-primary">{a.name}, VA</p>
                    <p className="text-sm text-muted-foreground">{a.county}</p>
                  </div>
                </div>
                <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="rounded-[2rem] overflow-hidden border border-border shadow-lg mt-12">
            <iframe
              title="Esprit Home Healthcare service area map"
              width="100%" height="380" style={{ border: 0 }} loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=Annandale,VA&z=10&output=embed"
            />
          </div>
        </Reveal>

        <div className="mt-10 text-center">
          <a href={COMPANY.phoneHref} className="inline-flex items-center gap-2 text-primary font-semibold text-lg">
            <Phone className="w-5 h-5" /> Don't see your town? Call {COMPANY.phone}
          </a>
        </div>
      </section>

      <ConsultationCTA title="Local care, wherever you call home" />
    </div>
  );
}
